import { Alternative } from "./alternative.model";

export class UserAnswer {

    constructor(
        public pessoaQuestionarioId: number,
        public mensagemCindiId: number,
        public questionTag: string,
        public alternativas: Alternative[] | null,
        public respostaTexto: string | null
    ) {}

}
